var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _g3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _circle, _g4, _path32, _circle2, _rect, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainGraphEn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 603,
    viewBox: "0 0 605 603",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.164 148.938C231.883 147.062 230.441 145.926 228.461 145.914C225.824 145.926 224.078 147.941 224.078 151.516C224.078 155.172 225.848 157.105 228.438 157.117C230.371 157.105 231.824 156.051 232.164 154.211L235.727 154.234C235.34 157.375 232.703 160.234 228.391 160.234C223.855 160.234 220.492 157.035 220.492 151.516C220.492 145.973 223.914 142.797 228.391 142.797C232.305 142.797 235.258 145.035 235.727 148.938H232.164ZM237.508 156.438C237.52 153.602 239.793 152.676 242.242 152.523C243.156 152.465 244.867 152.383 245.406 152.359V151.328C245.395 150.262 244.668 149.652 243.367 149.641C242.184 149.652 241.445 150.18 241.258 151.047H237.953C238.164 148.844 240.086 147.109 243.461 147.109C246.238 147.109 248.863 148.352 248.852 151.422V160H245.57V158.242H245.477C244.855 159.414 243.637 160.246 241.75 160.234C239.312 160.246 237.52 158.957 237.508 156.438ZM240.836 156.344C240.836 157.316 241.621 157.832 242.734 157.844C244.316 157.832 245.418 156.801 245.406 155.453V154.527C244.879 154.551 243.391 154.633 242.805 154.68C241.598 154.785 240.836 155.359 240.836 156.344ZM251.5 160V147.273H254.852V149.477H254.992C255.449 147.918 256.633 147.086 258.062 147.086C258.414 147.086 258.859 147.133 259.164 147.203V150.297C258.836 150.191 258.168 150.109 257.688 150.109C256.117 150.109 254.957 151.199 254.969 152.758V160H251.5ZM260.922 160V143.031H264.391V149.406H264.484C264.965 148.375 265.973 147.109 268.117 147.109C270.93 147.109 273.285 149.289 273.297 153.648C273.285 157.902 271.023 160.211 268.117 160.211C266.043 160.211 264.988 159.016 264.484 157.961H264.344V160H260.922ZM264.32 153.625C264.309 155.922 265.305 157.434 267.016 157.445C268.785 157.434 269.746 155.875 269.734 153.625C269.746 151.41 268.809 149.875 267.016 149.875C265.293 149.875 264.309 151.34 264.32 153.625ZM281.242 160.258C277.398 160.246 274.996 157.609 275.008 153.672C274.996 149.746 277.398 147.109 281.242 147.109C285.098 147.109 287.488 149.746 287.5 153.672C287.488 157.609 285.098 160.246 281.242 160.258ZM278.523 153.672C278.523 155.898 279.449 157.551 281.266 157.562C283.035 157.551 283.973 155.898 283.961 153.672C283.973 151.434 283.035 149.758 281.266 149.758C279.449 149.758 278.523 151.434 278.523 153.672ZM293.148 152.641V160H289.68V147.273H292.984V149.5H293.125C293.699 148.035 295.059 147.109 296.945 147.109C299.605 147.109 301.34 148.926 301.328 151.891V160H297.883V152.5C297.871 150.93 297.027 149.992 295.586 149.992C294.145 149.992 293.148 150.965 293.148 152.641ZM309.625 160V143.031H316.281C320.137 143.031 322.352 145.41 322.352 148.75C322.352 152.137 320.102 154.469 316.188 154.469H313.141V160H309.625ZM313.141 151.633H315.625C317.711 151.633 318.73 150.461 318.719 148.75C318.73 147.062 317.711 145.926 315.625 145.914H313.141V151.633ZM324.508 160V147.273H327.859V149.477H328C328.457 147.918 329.641 147.086 331.07 147.086C331.422 147.086 331.867 147.133 332.172 147.203V150.297C331.844 150.191 331.176 150.109 330.695 150.109C329.125 150.109 327.965 151.199 327.977 152.758V160H324.508ZM339.18 160.258C335.336 160.246 332.934 157.609 332.945 153.672C332.934 149.746 335.336 147.109 339.18 147.109C343.035 147.109 345.426 149.746 345.438 153.672C345.426 157.609 343.035 160.246 339.18 160.258ZM336.461 153.672C336.461 155.898 337.387 157.551 339.203 157.562C340.973 157.551 341.91 155.898 341.898 153.672C341.91 151.434 340.973 149.758 339.203 149.758C337.387 149.758 336.461 151.434 336.461 153.672ZM347.617 147.273H351.086V160.633C351.074 163.574 349.281 164.77 346.305 164.781L345.602 164.758V162.039C345.777 162.051 345.918 162.051 346.07 162.062C347.195 162.051 347.617 161.559 347.617 160.586V147.273ZM347.43 143.852C347.43 142.867 348.285 142.082 349.328 142.07C350.359 142.082 351.215 142.867 351.203 143.852C351.215 144.812 350.359 145.609 349.328 145.609C348.285 145.609 347.43 144.812 347.43 143.852ZM359.547 160.258C355.645 160.246 353.254 157.727 353.266 153.695C353.254 149.77 355.68 147.109 359.406 147.109C362.746 147.109 365.383 149.219 365.383 153.555V154.539H356.688C356.688 156.461 357.824 157.645 359.617 157.656C360.801 157.645 361.645 157.129 361.984 156.367H365.289C364.797 158.723 362.688 160.246 359.547 160.258ZM356.688 152.359H362.102C362.09 150.812 361.023 149.699 359.477 149.711C357.883 149.699 356.758 150.895 356.688 152.359ZM373.281 160.258C369.379 160.246 367.035 157.551 367.047 153.672C367.035 149.781 369.426 147.109 373.281 147.109C376.562 147.109 378.789 149.02 378.93 151.938H375.672C375.461 150.684 374.641 149.816 373.328 149.805C371.664 149.816 370.562 151.211 370.562 153.625C370.562 156.086 371.641 157.492 373.328 157.492C374.547 157.492 375.449 156.73 375.672 155.383H378.93C378.777 158.266 376.656 160.246 373.281 160.258ZM387.789 147.273V149.875H385.398V156.086C385.387 157.105 385.891 157.352 386.594 157.375C386.945 157.375 387.555 157.34 387.977 157.305V160.047C387.602 160.105 386.98 160.176 386.125 160.164C383.617 160.176 381.906 159.051 381.93 156.578V149.875H380.172V147.273H381.93V144.227H385.398V147.273H387.789ZM253.82 192H247.844V175.031H253.891C259 175.031 262.129 178.207 262.117 183.492C262.129 188.801 259 192 253.82 192ZM251.359 188.977H253.68C256.914 188.977 258.602 187.301 258.602 183.492C258.602 179.719 256.914 178.055 253.703 178.055H251.359V188.977ZM270.367 192.258C266.465 192.246 264.074 189.727 264.086 185.695C264.074 181.77 266.5 179.109 270.227 179.109C273.566 179.109 276.203 181.219 276.203 185.555V186.539H267.508C267.508 188.461 268.645 189.645 270.438 189.656C271.621 189.645 272.465 189.129 272.805 188.367H276.109C275.617 190.723 273.508 192.246 270.367 192.258ZM267.508 184.359H272.922C272.91 182.812 271.844 181.699 270.297 181.711C268.703 181.699 267.578 182.895 267.508 184.359ZM289.844 179.273L285.367 192H281.477L277.023 179.273H280.68L283.352 188.414H283.492L286.164 179.273H289.844ZM296.875 192.258C292.973 192.246 290.582 189.727 290.594 185.695C290.582 181.77 293.008 179.109 296.734 179.109C300.074 179.109 302.711 181.219 302.711 185.555V186.539H294.016C294.016 188.461 295.152 189.645 296.945 189.656C298.129 189.645 298.973 189.129 299.312 188.367H302.617C302.125 190.723 300.016 192.246 296.875 192.258ZM294.016 184.359H299.43C299.418 182.812 298.352 181.699 296.805 181.711C295.211 181.699 294.086 182.895 294.016 184.359ZM308.359 175.031V192H304.891V175.031H308.359ZM316.773 192.258C312.93 192.246 310.527 189.609 310.539 185.672C310.527 181.746 312.93 179.109 316.773 179.109C320.629 179.109 323.02 181.746 323.031 185.672C323.02 189.609 320.629 192.246 316.773 192.258ZM314.055 185.672C314.055 187.898 314.98 189.551 316.797 189.562C318.566 189.551 319.504 187.898 319.492 185.672C319.504 183.434 318.566 181.758 316.797 181.758C314.98 181.758 314.055 183.434 314.055 185.672ZM325.211 196.781V179.273H328.633V181.406H328.773C329.254 180.375 330.262 179.109 332.406 179.109C335.219 179.109 337.574 181.289 337.562 185.648C337.574 189.902 335.312 192.211 332.406 192.211C330.332 192.211 329.266 191.016 328.773 189.961H328.68V196.781H325.211ZM328.609 185.625C328.598 187.922 329.582 189.434 331.305 189.445C333.074 189.434 334.035 187.875 334.023 185.625C334.035 183.41 333.098 181.875 331.305 181.875C329.57 181.875 328.598 183.34 328.609 185.625ZM345.578 192.258C341.676 192.246 339.285 189.727 339.297 185.695C339.285 181.77 341.711 179.109 345.438 179.109C348.777 179.109 351.414 181.219 351.414 185.555V186.539H342.719C342.719 188.461 343.855 189.645 345.648 189.656C346.832 189.645 347.676 189.129 348.016 188.367H351.32C350.828 190.723 348.719 192.246 345.578 192.258ZM342.719 184.359H348.133C348.121 182.812 347.055 181.699 345.508 181.711C343.914 181.699 342.789 182.895 342.719 184.359ZM353.594 192V179.273H356.945V181.477H357.086C357.543 179.918 358.727 179.086 360.156 179.086C360.508 179.086 360.953 179.133 361.258 179.203V182.297C360.93 182.191 360.262 182.109 359.781 182.109C358.211 182.109 357.051 183.199 357.062 184.758V192H353.594Z",
    fill: "#5A6372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394 333C394 382.706 353.706 423 304 423C254.294 423 214 382.706 214 333C214 283.294 254.294 243 304 243C353.706 243 394 283.294 394 333Z",
    stroke: "#E1E6EF",
    strokeWidth: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_628_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.854 327.489C312.3 327.499 313.72 327.918 314.977 328.705C316.235 329.492 317.287 330.621 318.035 331.985C318.782 333.348 319.199 334.9 319.245 336.491C319.292 338.082 318.967 339.66 318.301 341.074C317.635 342.487 316.65 343.689 315.442 344.563C314.233 345.438 312.841 345.956 311.398 346.069C309.955 346.181 308.511 345.884 307.202 345.206C305.893 344.528 304.765 343.491 303.925 342.195C303.262 344.934 302.09 347.492 300.483 349.706C298.877 351.921 296.87 353.745 294.591 355.063V361.129H302.572V352.324C305.093 353.989 307.981 354.86 310.921 354.842C313.552 354.841 316.144 354.137 318.473 352.789C320.803 351.442 322.8 349.491 324.293 347.106C325.786 344.72 326.731 341.971 327.045 339.095C327.36 336.219 327.035 333.302 326.1 330.594C325.164 327.887 323.644 325.47 321.672 323.552C319.7 321.634 317.334 320.272 314.778 319.583C312.223 318.894 309.553 318.899 306.999 319.598C304.445 320.296 302.084 321.667 300.118 323.592C301.941 325.915 303.265 328.661 303.991 331.625C304.747 330.377 305.765 329.348 306.961 328.628C308.156 327.908 309.492 327.517 310.854 327.489V327.489Z",
    fill: "#5D3BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.864 352.122C254.642 353.315 256.617 354.109 258.675 354.456C261.048 354.886 263.479 354.728 265.789 353.993C268.1 353.259 270.233 351.966 272.033 350.21C270.189 347.901 268.847 345.16 268.109 342.195C267.231 343.502 266.054 344.53 264.698 345.173C263.342 345.816 261.855 346.052 260.389 345.856C258.923 345.66 257.53 345.039 256.353 344.057C255.176 343.075 254.257 341.767 253.689 340.267C253.121 338.766 252.925 337.126 253.12 335.515C253.316 333.903 253.896 332.378 254.802 331.094C255.708 329.81 256.907 328.813 258.276 328.206C259.646 327.599 261.138 327.402 262.599 327.636C264.643 328.038 266.49 329.228 267.809 330.993C269.127 332.759 269.832 334.983 269.796 337.269C269.885 341.359 271.241 345.293 273.64 348.419C276.038 351.544 279.336 353.673 282.984 354.452C286.633 355.231 290.414 354.614 293.7 352.702C296.986 350.791 299.58 347.701 301.052 343.943C302.524 340.186 302.785 335.988 301.792 332.045C300.798 328.102 298.611 324.652 295.592 322.265C292.573 319.879 288.904 318.7 285.193 318.925C281.482 319.149 277.952 320.764 275.189 323.5C277.035 325.844 278.366 328.624 279.079 331.625C279.927 330.281 281.086 329.21 282.436 328.523C283.786 327.837 285.278 327.56 286.758 327.721C288.237 327.882 289.651 328.475 290.853 329.439C292.055 330.403 293.001 331.702 293.594 333.204C294.186 334.705 294.404 336.353 294.224 337.978C294.045 339.603 293.474 341.146 292.571 342.447C291.669 343.748 290.467 344.76 289.09 345.378C287.713 345.996 286.211 346.198 284.74 345.964C282.794 345.612 281.02 344.531 279.717 342.902C278.414 341.273 277.664 339.198 277.593 337.03C277.025 324.456 268.927 320.026 263.835 319.125C261.727 318.75 259.573 318.837 257.496 319.38C255.419 319.923 253.459 320.912 251.73 322.29C250.001 323.668 248.535 325.408 247.417 327.411C246.3 329.413 245.552 331.639 245.217 333.96C245.087 334.872 245.014 335.794 245 336.717V361H252.864V352.122Z",
    fill: "#5D3BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.754 318.959C344.424 318.958 342.121 319.511 340.003 320.58C337.884 321.649 336.001 323.209 334.481 325.154V310.944H326.5V325.816C328.398 329.091 329.407 332.895 329.407 336.781C329.407 340.666 328.398 344.47 326.5 347.746V354.529H334.481V348.444C336.373 350.867 338.82 352.687 341.568 353.713C344.316 354.74 347.264 354.936 350.104 354.28C352.944 353.625 355.572 352.142 357.714 349.987C359.856 347.832 361.434 345.084 362.282 342.029H353.717C352.809 343.471 351.548 344.6 350.081 345.285C348.614 345.97 347.001 346.184 345.428 345.901C343.855 345.618 342.387 344.851 341.195 343.687C340.002 342.524 339.133 341.012 338.689 339.327H362.883C362.989 338.48 363.045 337.626 363.05 336.772C363.033 332.031 361.306 327.492 358.251 324.152C355.195 320.812 351.06 318.944 346.754 318.959V318.959ZM339.24 332.617C339.924 331.063 340.991 329.753 342.32 328.836C343.649 327.919 345.185 327.432 346.754 327.432C348.322 327.432 349.859 327.919 351.188 328.836C352.517 329.753 353.584 331.063 354.268 332.617H339.24Z",
    fill: "#5D3BE5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M473.785 583.938C473.504 582.062 472.062 580.926 470.082 580.914C467.445 580.926 465.699 582.941 465.699 586.516C465.699 590.172 467.469 592.105 470.059 592.117C471.992 592.105 473.445 591.051 473.785 589.211L477.348 589.234C476.961 592.375 474.324 595.234 470.012 595.234C465.477 595.234 462.113 592.035 462.113 586.516C462.113 580.973 465.535 577.797 470.012 577.797C473.926 577.797 476.879 580.035 477.348 583.938H473.785ZM485.457 595.258C481.613 595.246 479.211 592.609 479.223 588.672C479.211 584.746 481.613 582.109 485.457 582.109C489.312 582.109 491.703 584.746 491.715 588.672C491.703 592.609 489.312 595.246 485.457 595.258ZM482.738 588.672C482.738 590.898 483.664 592.551 485.48 592.562C487.25 592.551 488.188 590.898 488.176 588.672C488.188 586.434 487.25 584.758 485.48 584.758C483.664 584.758 482.738 586.434 482.738 588.672ZM493.895 595V582.273H497.199V584.5H497.34C497.879 583.012 499.168 582.109 500.879 582.109C502.625 582.109 503.926 583.035 504.348 584.5H504.465C504.992 583.059 506.445 582.109 508.309 582.109C510.664 582.109 512.316 583.668 512.316 586.445V595H508.848V587.125C508.859 585.672 507.992 584.969 506.855 584.969C505.555 584.969 504.781 585.871 504.793 587.219V595H501.418V587.031C501.43 585.777 500.633 584.969 499.449 584.969C498.266 584.969 497.352 585.918 497.363 587.359V595H493.895ZM514.988 599.781V582.273H518.41V584.406H518.551C519.031 583.375 520.039 582.109 522.184 582.109C524.996 582.109 527.352 584.289 527.34 588.648C527.352 592.902 525.09 595.211 522.184 595.211C520.109 595.211 519.043 594.016 518.551 592.961H518.457V599.781H514.988ZM518.387 588.625C518.375 590.922 519.359 592.434 521.082 592.445C522.852 592.434 523.812 590.875 523.801 588.625C523.812 586.41 522.875 584.875 521.082 584.875C519.348 584.875 518.375 586.34 518.387 588.625ZM528.98 591.438C528.992 588.602 531.266 587.676 533.715 587.523C534.629 587.465 536.34 587.383 536.879 587.359V586.328C536.867 585.262 536.141 584.652 534.84 584.641C533.656 584.652 532.918 585.18 532.73 586.047H529.426C529.637 583.844 531.559 582.109 534.934 582.109C537.711 582.109 540.336 583.352 540.324 586.422V595H537.043V593.242H536.949C536.328 594.414 535.109 595.246 533.223 595.234C530.785 595.246 528.992 593.957 528.98 591.438ZM532.309 591.344C532.309 592.316 533.094 592.832 534.207 592.844C535.789 592.832 536.891 591.801 536.879 590.453V589.527C536.352 589.551 534.863 589.633 534.277 589.68C533.07 589.785 532.309 590.359 532.309 591.344ZM546.441 587.641V595H542.973V582.273H546.277V584.5H546.418C546.992 583.035 548.352 582.109 550.238 582.109C552.898 582.109 554.633 583.926 554.621 586.891V595H551.176V587.5C551.164 585.93 550.32 584.992 548.879 584.992C547.438 584.992 546.441 585.965 546.441 587.641ZM558.887 599.781C558.207 599.77 557.574 599.758 557.129 599.711V597.016C557.574 597.051 558.102 597.062 558.535 597.062C559.227 597.062 559.777 596.992 560.199 595.891L560.41 595.352L555.84 582.273H559.473L562.145 591.648H562.285L564.98 582.273H568.66L563.691 596.406C562.965 598.457 561.57 599.77 558.887 599.781Z",
    fill: "#5A6372"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M440 371C440 362.716 446.716 356 455 356H575C583.284 356 590 362.716 590 371V371C590 379.284 583.284 386 575 386H455C446.716 386 440 379.284 440 371V371Z",
    fill: "#8A97AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M470.977 369.703C470.766 368.297 469.685 367.444 468.199 367.436C466.222 367.444 464.912 368.956 464.912 371.637C464.912 374.379 466.239 375.829 468.182 375.838C469.632 375.829 470.722 375.038 470.977 373.658L473.648 373.676C473.358 376.031 471.381 378.176 468.146 378.176C464.745 378.176 462.223 375.776 462.223 371.637C462.223 367.479 464.789 365.098 468.146 365.098C471.082 365.098 473.297 366.776 473.648 369.703H470.977ZM479.766 378.193C476.839 378.185 475.046 376.295 475.055 373.271C475.046 370.327 476.865 368.332 479.66 368.332C482.165 368.332 484.143 369.914 484.143 373.166V373.904H477.621C477.621 375.346 478.474 376.233 479.818 376.242C480.706 376.233 481.339 375.847 481.594 375.275H484.072C483.703 377.042 482.121 378.185 479.766 378.193ZM477.621 372.27H481.682C481.673 371.109 480.873 370.274 479.713 370.283C478.518 370.274 477.674 371.171 477.621 372.27ZM485.777 378V368.455H488.291V370.107H488.396C488.739 368.938 489.627 368.314 490.699 368.314C490.963 368.314 491.297 368.35 491.525 368.402V370.723C491.279 370.644 490.778 370.582 490.418 370.582C489.24 370.582 488.37 371.399 488.379 372.568V378H485.777ZM498.293 368.455V370.406H496.5V375.064C496.491 375.829 496.869 376.014 497.396 376.031C497.66 376.031 498.117 376.005 498.434 375.979V378.035C498.152 378.079 497.687 378.132 497.045 378.123C495.164 378.132 493.881 377.288 493.898 375.434V370.406H492.58V368.455H493.898V366.17H496.5V368.455H498.293ZM499.928 378V368.455H502.529V378H499.928ZM499.805 365.889C499.805 365.15 500.446 364.562 501.229 364.553C502.002 364.562 502.644 365.15 502.635 365.889C502.644 366.609 502.002 367.207 501.229 367.207C500.446 367.207 499.805 366.609 499.805 365.889ZM509.631 368.455V370.406H507.732V378H505.131V370.406H503.777V368.455H505.131V367.734C505.131 365.722 506.344 364.676 508.26 364.676C508.849 364.676 509.35 364.729 509.807 364.834V366.803C509.429 366.768 509.156 366.759 509.016 366.75C508.181 366.759 507.732 367.075 507.732 367.875V368.455H509.631ZM511.16 378V368.455H513.762V378H511.16ZM511.037 365.889C511.037 365.15 511.679 364.562 512.461 364.553C513.234 364.562 513.876 365.15 513.867 365.889C513.876 366.609 513.234 367.207 512.461 367.207C511.679 367.207 511.037 366.609 511.037 365.889ZM520.072 378.193C517.146 378.185 515.388 376.163 515.396 373.254C515.388 370.336 517.181 368.332 520.072 368.332C522.533 368.332 524.203 369.765 524.309 371.953H521.865C521.707 371.013 521.092 370.362 520.107 370.354C518.859 370.362 518.033 371.408 518.033 373.219C518.033 375.064 518.842 376.119 520.107 376.119C521.021 376.119 521.698 375.548 521.865 374.537H524.309C524.194 376.699 522.604 378.185 520.072 378.193ZM525.469 375.328C525.478 373.201 527.183 372.507 529.02 372.393C529.705 372.349 530.988 372.287 531.393 372.27V371.496C531.384 370.696 530.839 370.239 529.863 370.23C528.976 370.239 528.422 370.635 528.281 371.285H525.803C525.961 369.633 527.402 368.332 529.934 368.332C532.017 368.332 533.985 369.264 533.977 371.566V378H531.516V376.682H531.445C530.979 377.561 530.065 378.185 528.65 378.176C526.822 378.185 525.478 377.218 525.469 375.328ZM527.965 375.258C527.965 375.987 528.554 376.374 529.389 376.383C530.575 376.374 531.401 375.601 531.393 374.59V373.896C530.997 373.913 529.881 373.975 529.441 374.01C528.536 374.089 527.965 374.52 527.965 375.258ZM540.99 368.455V370.406H539.197V375.064C539.188 375.829 539.566 376.014 540.094 376.031C540.357 376.031 540.814 376.005 541.131 375.979V378.035C540.85 378.079 540.384 378.132 539.742 378.123C537.861 378.132 536.578 377.288 536.596 375.434V370.406H535.277V368.455H536.596V366.17H539.197V368.455H540.99ZM542.625 378V368.455H545.227V378H542.625ZM542.502 365.889C542.502 365.15 543.144 364.562 543.926 364.553C544.699 364.562 545.341 365.15 545.332 365.889C545.341 366.609 544.699 367.207 543.926 367.207C543.144 367.207 542.502 366.609 542.502 365.889ZM551.537 378.193C548.654 378.185 546.853 376.207 546.861 373.254C546.853 370.31 548.654 368.332 551.537 368.332C554.429 368.332 556.222 370.31 556.23 373.254C556.222 376.207 554.429 378.185 551.537 378.193ZM549.498 373.254C549.498 374.924 550.192 376.163 551.555 376.172C552.882 376.163 553.585 374.924 553.576 373.254C553.585 371.575 552.882 370.318 551.555 370.318C550.192 370.318 549.498 371.575 549.498 373.254ZM560.467 372.48V378H557.865V368.455H560.344V370.125H560.449C560.88 369.026 561.899 368.332 563.314 368.332C565.31 368.332 566.61 369.694 566.602 371.918V378H564.018V372.375C564.009 371.197 563.376 370.494 562.295 370.494C561.214 370.494 560.467 371.224 560.467 372.48Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0664 578.031V595H36.5508V578.031H40.0664ZM46.3242 587.641V595H42.8555V582.273H46.1602V584.5H46.3008C46.875 583.035 48.2344 582.109 50.1211 582.109C52.7812 582.109 54.5156 583.926 54.5039 586.891V595H51.0586V587.5C51.0469 585.93 50.2031 584.992 48.7617 584.992C47.3203 584.992 46.3242 585.965 46.3242 587.641ZM61.8867 595.211C58.9805 595.211 56.707 592.902 56.707 588.648C56.707 584.289 59.0742 582.109 61.8867 582.109C64.0195 582.109 65.0391 583.375 65.4961 584.406H65.6133V578.031H69.082V595H65.6602V592.961H65.4961C65.0156 594.016 63.9609 595.211 61.8867 595.211ZM60.2695 588.625C60.2578 590.875 61.207 592.434 62.9648 592.445C64.6992 592.434 65.6836 590.922 65.6836 588.625C65.6836 586.34 64.7109 584.875 62.9648 584.875C61.1953 584.875 60.2578 586.41 60.2695 588.625ZM71.8711 595V582.273H75.3398V595H71.8711ZM71.707 578.852C71.707 577.867 72.5625 577.082 73.6055 577.07C74.6367 577.082 75.4922 577.867 75.4805 578.852C75.4922 579.812 74.6367 580.609 73.6055 580.609C72.5625 580.609 71.707 579.812 71.707 578.852ZM89.8477 582.273L85.3711 595H81.4805L77.0273 582.273H80.6836L83.3555 591.414H83.4961L86.168 582.273H89.8477ZM91.5352 595V582.273H95.0039V595H91.5352ZM91.3711 578.852C91.3711 577.867 92.2266 577.082 93.2695 577.07C94.3008 577.082 95.1562 577.867 95.1445 578.852C95.1562 579.812 94.3008 580.609 93.2695 580.609C92.2266 580.609 91.3711 579.812 91.3711 578.852ZM102.387 595.211C99.4805 595.211 97.207 592.902 97.207 588.648C97.207 584.289 99.5742 582.109 102.387 582.109C104.52 582.109 105.539 583.375 105.996 584.406H106.113V578.031H109.582V595H106.16V592.961H105.996C105.516 594.016 104.461 595.211 102.387 595.211ZM100.77 588.625C100.758 590.875 101.707 592.434 103.465 592.445C105.199 592.434 106.184 590.922 106.184 588.625C106.184 586.34 105.211 584.875 103.465 584.875C101.695 584.875 100.758 586.41 100.77 588.625ZM120.527 589.586V582.273H123.996V595H120.668V592.703H120.527C119.953 594.18 118.582 595.164 116.66 595.164C114.117 595.164 112.371 593.359 112.371 590.383V582.273H115.84V589.773C115.84 591.285 116.707 592.223 118.066 592.234C119.332 592.223 120.527 591.32 120.527 589.586ZM126.082 591.438C126.094 588.602 128.367 587.676 130.816 587.523C131.73 587.465 133.441 587.383 133.98 587.359V586.328C133.969 585.262 133.242 584.652 131.941 584.641C130.758 584.652 130.02 585.18 129.832 586.047H126.527C126.738 583.844 128.66 582.109 132.035 582.109C134.812 582.109 137.438 583.352 137.426 586.422V595H134.145V593.242H134.051C133.43 594.414 132.211 595.246 130.324 595.234C127.887 595.246 126.094 593.957 126.082 591.438ZM129.41 591.344C129.41 592.316 130.195 592.832 131.309 592.844C132.891 592.832 133.992 591.801 133.98 590.453V589.527C133.453 589.551 131.965 589.633 131.379 589.68C130.172 589.785 129.41 590.359 129.41 591.344ZM143.543 578.031V595H140.074V578.031H143.543Z",
    fill: "#5A6372"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165 371C165 379.284 158.284 386 150 386H30C21.7157 386 15 379.284 15 371V371C15 362.716 21.7157 356 30 356H150C158.284 356 165 362.716 165 371V371Z",
    fill: "#8A97AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7363 367.453V365.273H68.1602V367.453H64.2578V378H61.6387V367.453H57.7363ZM68.7402 378V368.455H71.2539V370.107H71.3594C71.7021 368.938 72.5898 368.314 73.6621 368.314C73.9258 368.314 74.2598 368.35 74.4883 368.402V370.723C74.2422 370.644 73.7412 370.582 73.3809 370.582C72.2031 370.582 71.333 371.399 71.3418 372.568V378H68.7402ZM75.0332 375.328C75.042 373.201 76.7471 372.507 78.584 372.393C79.2695 372.349 80.5527 372.287 80.957 372.27V371.496C80.9482 370.696 80.4033 370.239 79.4277 370.23C78.54 370.239 77.9863 370.635 77.8457 371.285H75.3672C75.5254 369.633 76.9668 368.332 79.498 368.332C81.5811 368.332 83.5498 369.264 83.541 371.566V378H81.0801V376.682H81.0098C80.5439 377.561 79.6299 378.185 78.2148 378.176C76.3867 378.185 75.042 377.218 75.0332 375.328ZM77.5293 375.258C77.5293 375.987 78.1182 376.374 78.9531 376.383C80.1396 376.374 80.9658 375.601 80.957 374.59V373.896C80.5615 373.913 79.4453 373.975 79.0059 374.01C78.1006 374.089 77.5293 374.52 77.5293 375.258ZM89.043 378.158C86.8633 378.158 85.1582 376.427 85.1582 373.236C85.1582 369.967 86.9336 368.332 89.043 368.332C90.6426 368.332 91.4072 369.281 91.75 370.055H91.8379V365.273H94.4395V378H91.873V376.471H91.75C91.3896 377.262 90.5986 378.158 89.043 378.158ZM87.8301 373.219C87.8213 374.906 88.5332 376.075 89.8516 376.084C91.1523 376.075 91.8906 374.941 91.8906 373.219C91.8906 371.505 91.1611 370.406 89.8516 370.406C88.5244 370.406 87.8213 371.558 87.8301 373.219ZM96.5312 378V368.455H99.1328V378H96.5312ZM96.4082 365.889C96.4082 365.15 97.0498 364.562 97.832 364.553C98.6055 364.562 99.2471 365.15 99.2383 365.889C99.2471 366.609 98.6055 367.207 97.832 367.207C97.0498 367.207 96.4082 366.609 96.4082 365.889ZM103.756 372.48V378H101.154V368.455H103.633V370.125H103.738C104.169 369.026 105.188 368.332 106.604 368.332C108.599 368.332 109.899 369.694 109.891 371.918V378H107.307V372.375C107.298 371.197 106.665 370.494 105.584 370.494C104.503 370.494 103.756 371.224 103.756 372.48ZM116.201 381.779C113.564 381.779 111.938 380.593 111.789 378.791H114.355C114.496 379.556 115.217 379.898 116.254 379.898C117.458 379.898 118.267 379.38 118.275 378.053V376.312H118.152C117.81 377.086 116.966 377.868 115.428 377.859C113.274 377.868 111.543 376.348 111.543 373.166C111.543 369.94 113.318 368.332 115.428 368.332C117.027 368.332 117.801 369.281 118.152 370.055H118.258V368.455H120.842V378.105C120.833 380.54 118.917 381.779 116.201 381.779ZM114.215 373.201C114.206 374.854 114.918 375.899 116.236 375.908C117.537 375.899 118.275 374.897 118.275 373.201C118.275 371.505 117.546 370.406 116.236 370.406C114.909 370.406 114.206 371.558 114.215 373.201Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311 225H297V262.434H289.004C287.377 262.434 286.431 264.272 287.376 265.596L301.943 285.99C302.741 287.107 304.401 287.107 305.198 285.99L319.765 265.596C320.711 264.272 319.765 262.434 318.138 262.434H311V225Z",
    fill: "url(#paint0_linear_628_1579)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.971 371.464L362.071 381.364L388.541 407.833L382.886 413.487C381.736 414.638 382.367 416.607 383.972 416.874L408.693 420.995C410.047 421.22 411.22 420.047 410.995 418.693L406.874 393.972C406.607 392.367 404.638 391.736 403.487 392.886L398.44 397.933L371.971 371.464Z",
    fill: "url(#paint1_linear_628_1579)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.183 371.464L245.082 381.364L218.613 407.833L224.267 413.487C225.417 414.638 224.786 416.607 223.182 416.874L198.46 420.995C197.107 421.22 195.933 420.047 196.159 418.693L200.279 393.972C200.546 392.367 202.516 391.736 203.666 392.886L208.713 397.933L235.183 371.464Z",
    fill: "url(#paint2_linear_628_1579)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.607 31.8135C269.607 19.6632 259.758 9.81348 247.607 9.81348C235.457 9.81348 225.607 19.6632 225.607 31.8135C225.607 43.9637 235.457 53.8135 247.607 53.8135C259.758 53.8135 269.607 43.9637 269.607 31.8135Z",
    fill: "url(#paint3_linear_628_1579)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.67 53.5762L246.281 60.6849",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M249.402 3L249.014 10.1087",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M269.575 33.0146L276.684 33.4033",
    stroke: "#FF9898",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219 30.2812L226.109 30.6699",
    stroke: "#FF9898",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.38 48.0352L267.132 53.3385",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228.554 10.3467L233.305 15.6375",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.637 46.3799L226.347 51.1316",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M269.338 12.5537L264.034 17.3054",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238.207 51.3564L235.048 57.738",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.623 5.94629L257.477 12.3278",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M254.833 52.4609L257.115 59.1935",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M238.571 4.49219L240.853 11.2248",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.109 30.6699L219 30.2812",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.684 33.4033L269.575 33.0146",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.356 41.4775L273.738 44.6244",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.946 19.0479L228.328 22.2073",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.46 24.8531L275.193 22.5713",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M220.492 41.1138L227.225 38.832",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M325.577 61.7686V110.801",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M263.609 94.3516V110.8",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M252.712 111.627H335.119",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_628_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.002 96.5992H230.237L251.843 45.4521H335.608L314.002 96.5992Z",
    fill: "url(#paint4_linear_628_1579)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_628_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.753 94.3512H228.988L250.594 43.2041H334.359L312.753 94.3512Z",
    fill: "url(#paint5_linear_628_1579)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 252.361 44.8135)",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 263.476 44.2031)",
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 275.962 44.2031)",
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 288.447 44.2031)",
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 300.934 44.2031)",
    stroke: "white"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 313.419 44.2031)",
    stroke: "white"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 325.905 44.2031)",
    stroke: "white"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 331.608 45.3545)",
    stroke: "white"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 327.188 56.8701)",
    stroke: "white"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 322.77 68.3848)",
    stroke: "white"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 318.35 79.9004)",
    stroke: "white"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 313.93 91.416)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_628_1579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 411,
    width: 140,
    height: 140
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 481,
    r: 70,
    fill: "#5D38E5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_628_1579)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_628_1579)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 481,
    r: 70,
    fill: "url(#paint6_linear_628_1579)"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 487.286C74.3451 487.286 60.7179 496.049 55.8806 508.21C53.8394 513.342 58.4771 517.972 64 517.972H116.8C122.323 517.972 126.961 513.342 124.919 508.21C120.082 496.049 106.455 487.286 90.4 487.286Z",
    fill: "url(#paint7_linear_628_1579)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.1006,
    cy: 462.5,
    r: 17.5,
    fill: "url(#paint8_linear_628_1579)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 461,
    y: 457,
    width: 64,
    height: 84,
    rx: 10,
    fill: "url(#paint9_linear_628_1579)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 422,
    width: 77,
    height: 119,
    rx: 10,
    fill: "url(#paint10_linear_628_1579)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 440,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint11_linear_628_1579)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 440,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint12_linear_628_1579)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 457,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint13_linear_628_1579)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 474,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint14_linear_628_1579)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 457,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint15_linear_628_1579)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533,
    y: 474,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint16_linear_628_1579)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_628_1579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519,
    y: 505,
    width: 24,
    height: 36,
    rx: 2,
    fill: "url(#paint17_linear_628_1579)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_628_1579",
    x: 226.237,
    y: 41.4521,
    width: 113.371,
    height: 59.1475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_628_1579",
    x: 224.988,
    y: 39.2041,
    width: 113.371,
    height: 59.1475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_628_1579",
    x: 20,
    y: 411,
    width: 157,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_628_1579",
    x: 486,
    y: 418,
    width: 85,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_628_1579",
    x: 497,
    y: 436,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_628_1579",
    x: 529,
    y: 436,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_628_1579",
    x: 497,
    y: 453,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_628_1579",
    x: 497,
    y: 470,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_628_1579",
    x: 529,
    y: 453,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_628_1579",
    x: 529,
    y: 470,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_628_1579",
    x: 515,
    y: 501,
    width: 32,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_628_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_628_1579",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_628_1579",
    x1: 304,
    y1: 225,
    x2: 319.035,
    y2: 283.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_628_1579",
    x1: 367.021,
    y1: 376.414,
    x2: 418.742,
    y2: 406.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_628_1579",
    x1: 240.133,
    y1: 376.414,
    x2: 188.411,
    y2: 406.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_628_1579",
    x1: 225.607,
    y1: 31.8135,
    x2: 269.607,
    y2: 31.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_628_1579",
    x1: 230.237,
    y1: 98.1036,
    x2: 244.568,
    y2: 25.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_628_1579",
    x1: 228.988,
    y1: 95.8555,
    x2: 243.319,
    y2: 23.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_628_1579",
    x1: 141,
    y1: 417.5,
    x2: 39,
    y2: 543.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129404,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_628_1579",
    x1: 90.4,
    y1: 487.286,
    x2: 90.4,
    y2: 517.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_628_1579",
    x1: 91.1006,
    y1: 445,
    x2: 91.1006,
    y2: 480,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_628_1579",
    x1: 493,
    y1: 457,
    x2: 493,
    y2: 541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_628_1579",
    x1: 490,
    y1: 544.5,
    x2: 569,
    y2: 419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_628_1579",
    x1: 528.5,
    y1: 440,
    x2: 501,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_628_1579",
    x1: 560.5,
    y1: 440,
    x2: 533,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_628_1579",
    x1: 528.5,
    y1: 457,
    x2: 501,
    y2: 467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_628_1579",
    x1: 528.5,
    y1: 474,
    x2: 501,
    y2: 484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_628_1579",
    x1: 560.5,
    y1: 457,
    x2: 533,
    y2: 467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_628_1579",
    x1: 560.5,
    y1: 474,
    x2: 533,
    y2: 484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_628_1579",
    x1: 546.5,
    y1: 505,
    x2: 515.678,
    y2: 508.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_628_1579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 50,
    fill: "white",
    transform: "translate(245 311)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainGraphEn);
export default __webpack_public_path__ + "static/media/main_graph_en.2db63e5bbc720b132b7dabda691f71b0.svg";
export { ForwardRef as ReactComponent };